import {
    TextField,
    Button,
    Paper,
    Tabs,
    Tab,
    Modal,
    Box
} from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

// Styled components
export const Container = styled('div')({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    overflow: 'auto',
});

export const ResultTypeIcon = styled('div')({
    display: 'inline-flex',
    alignItems: 'center',
    marginRight: '10px', 
    '& img': {
        width: '20px', 
        height: '20px',
    },
    '& .MuiSvgIcon-root': { 
        fontSize: '20px', 
        color: 'rgba(0, 0, 0, 0.5)',
    },
});

export const FullContentModal = styled(Modal)({
});

export const ModalContent = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxWidth: '800px',
    maxHeight: '80vh',
    overflowY: 'auto',
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: theme.shape.borderRadius * 2,
    boxShadow: theme.shadows[24],
    padding: theme.spacing(3),
    textAlign: 'justify',
    '&:focus': {
        outline: 'none',
    },
}));

export const SectionTitle = styled('h2')({
    fontSize: '1.2rem',
    fontWeight: 600,
    color: 'var(--primary-main)',
    marginBottom: '10px',
});

export const SearchBox = styled(Paper)({
    padding: '25px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    marginBottom: '20px',
});

export const SearchForm = styled('div')({
    display: 'flex',
    gap: '10px',

    '@media (max-width: 768px)': {
        flexDirection: 'column',
    },
});

export const SearchInput = styled(TextField)({
    flex: 1,
});

export const SearchButton = styled(Button)({
    backgroundColor: 'var(--secondary-main)',
    color: '#fff',
    height: '56px',
    width: '150px',

    '&:hover': {
        backgroundColor: 'var(--secondary-dark)',
    },

    '@media (max-width: 768px)': {
        width: '100%',
    },
});

export const FilterSection = styled('div')({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    marginTop: '20px',
});

export const ResultTabs = styled(Tabs)({
    marginBottom: '20px',

    '& .MuiTabs-indicator': {
        backgroundColor: 'var(--secondary-main)',
    },
});

export const CustomTab = styled(Tab)({
    '&.Mui-selected': {
        color: 'var(--secondary-main)',
    },
});

export const ResultsContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
});

export const ResultCard = styled(Paper)({
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    transition: 'transform 0.2s ease',

    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
});

export const ResultTitle = styled('h3')({
    fontSize: '1.1rem',
    fontWeight: 500,
    marginTop: 0,
    marginBottom: '10px',
    color: 'var(--primary-main)',
});

export const ResultMeta = styled('div')({
    display: 'flex',
    gap: '20px',
    marginBottom: '15px',
    fontSize: '0.85rem',
    color: 'rgba(0, 0, 0, 0.5)',
});

export const ResultExcerpt = styled('p')({
    margin: '0 0 15px 0',
    fontSize: '0.95rem',
    lineHeight: '1.5',
});

export const ResultHighlight = styled('span')({
    backgroundColor: 'rgba(185, 161, 104, 0.2)',
    padding: '2px 0',
});

export const ResultActions = styled('div')({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
});

export const RelevanceBadge = styled('span')(({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 8px',
    backgroundColor: alpha(theme.palette.secondary.main, 0.1),
    color: theme.palette.secondary.main,
    borderRadius: '4px',
    fontSize: '0.8rem',
    fontWeight: 500,
}));

export const RelatedSection = styled(Paper)({
    padding: '20px',
    marginTop: '30px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
});

export const RelatedTitle = styled('h3')({
    fontSize: '1.1rem',
    fontWeight: 500,
    marginTop: 0,
    marginBottom: '15px',
});

export const RelatedTags = styled('div')({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    marginBottom: '20px',
});

export const AccordionContainer = styled('div')({
    marginTop: '20px',
});

export const AccordionTitle = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
});